export default __webpack_public_path__ + "static/media/Rajwada_Palace_Indore.b52e6e99.jpg";